import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DescadastroEmailResultado } from '../model/descadastro/descadastro-email-resultado.model';

@Injectable({
  providedIn: 'root'
})
export class DescadastroEmailService {

  private readonly http = inject(HttpClient);

  private urlBase: string = environment.urlBase.concat('/public/email/descadastro');

  confirmarDescadastro(uuid: string, email: string): Observable<DescadastroEmailResultado> {
    const params = new HttpParams().set('uuid', uuid).set('email', email);
    return this.http.get<DescadastroEmailResultado>(this.urlBase, { params, headers: { 'no-loading': 'true' } });
  }
}
